export default {
      id: "help-center-what-is-new-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "icons.svg#help-center-what-is-new",
      toString: function () {
        return this.url;
      }
    }